module.exports = __webpack_public_path__ + "static/img/nbzs.79820aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbzs.jpg
// module id = 1sxw
// module chunks = 1